// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__1ofn8","row":"ProcedureTreatmentSummary_row__1GhMC"};